import React, { useState, useEffect, useRef } from "react";
import { FiSearch } from "react-icons/fi";
import { useApiRequestMutation } from "../../services/apiService";
import { useGetAllRoelsMutation } from "./Api";
import ToastrService from "../../services/toastService";
import AddRoles from "./AddRoles";
import { toTitleCase } from "../../services/utils";
import Loader from "../loader/loader";
import { useNavigate } from "react-router-dom";
import Pagination from '../Pagination/Pagination'
import { FaEdit } from "react-icons/fa";


const RolesAndPermissions = () => {

    const navigate = useNavigate()

    const [getAllRolesApi, { isLoading }] = useGetAllRoelsMutation()

    const [role, setRole] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [status, setStatus] = useState(false)
    const [search, setSearch] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState(search);

    // useEffect(() => {
    //     getAllRoles()
    // }, [rowsPerPage, currentPage, status]);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(search);
        }, 1000); // 1000ms delay

        return () => clearTimeout(handler); // cleanup on next effect
    }, [search]);

    useEffect(() => {
        getAllRoles()
    }, [rowsPerPage, currentPage, status, debouncedSearch]);

    const getAllRoles = async () => {
        try {
            const response = await getAllRolesApi({
                page: currentPage,
                limit: rowsPerPage,
                search: debouncedSearch
            })
            // console.log(response.data.data, 'response')
            setRole(response?.data?.data?.roles)
            setTotalRecords(response?.data?.data?.pagination.total || 0);
            setTotalPages(response?.data?.data?.pagination.totalPages || 1);
        } catch (err) {
            console.log(err, 'err')
        }
    }

    const startEntry = totalRecords === 0
        ? 0
        : (currentPage - 1) * rowsPerPage + 1;

    const endEntry = Math.min(currentPage * rowsPerPage, totalRecords);



    /*Drawerr open close*/
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    // Open drawer for creating new user
    const handleCreateUser = () => {
        console.log('=====')
        setIsDrawerOpen(true);
    };

    const handleCloseDrawer = () => {
        setIsDrawerOpen(false);
    };

    const handleSave = (userData) => {
        console.log("New user data:", userData);
        // Call API here to save user
        handleCloseDrawer();
        // for get new data after new role upload
        setStatus(true)

    };


    return (
        <div>
            {isLoading ? <Loader /> :
                <div>
                    {/* Header */}
                    <div className="page-header">
                        <div className="page-header-left d-flex align-items-center">
                            <ul className="breadcrumb mb-0">
                                <li className="breadcrumb-item">Roles & Permission Management</li>
                                <li className="breadcrumb-item active">Profiles</li>
                            </ul>
                        </div>
                    </div>

                    <div className="main-content">
                        <div className="row">
                            <div className="p-6">
                                {/* Title */}

                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <div>
                                        <h3 className="h4 mb-1 drawer-header">
                                            Roles & Permission
                                        </h3>
                                        <p className="mb-0 text-muted">
                                            Manage Roles and Permissions.
                                        </p>
                                    </div>
                                    <button className="btn btn-primary" onClick={handleCreateUser}>
                                        Create Roles
                                    </button>
                                </div>


                                <div className="card p-3 mb-4">

                                    <div className="card shadow-sm border-0 p-3 mb-4">
                                        <div className="row justify-content-end g-3">

                                            {/* Search */}
                                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                                                {/* <label className="form-label small text-muted mb-1">Search</label> */}
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Search role by name..."
                                                    value={search}
                                                    onChange={(e) => setSearch(e.target.value)}
                                                />
                                            </div>

                                        </div>
                                    </div>

                                    <div className="table-responsive">
                                        <table className="table table-hover mb-0">
                                            <thead>
                                                <tr>
                                                    <th>Role Name</th>
                                                    <th>Description</th>
                                                    <th>Created By</th>
                                                    <th>Total User</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {!isLoading && role?.length > 0 ? role?.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            {item.role_displayname}
                                                        </td>
                                                        <td style={{
                                                            whiteSpace: "normal",
                                                            wordBreak: "break-word",
                                                            maxWidth: "250px"
                                                        }}>
                                                            {item.role_description}
                                                        </td>
                                                        <td>
                                                            Admin
                                                        </td>
                                                        <td>
                                                            {item.user_count}
                                                        </td>
                                                        <td style={{ cursor: "pointer" }}
                                                            onClick={() => navigate(`/manageRole/${item.id}`)}>
                                                            <FaEdit size={18} />
                                                        </td>
                                                    </tr>
                                                )) : (
                                                    <tr>
                                                        <td colSpan="5" className="text-center text-muted py-4" style={{ fontStyle: "italic", backgroundColor: "#f9f9f9" }}>
                                                            No data found
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                        {/* Pagination */}

                                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-3 gap-2">

                                            <div className="d-flex align-items-center gap-1 small">

                                                <span>Show</span>

                                                <select
                                                    className="form-select form-select-sm page-size-select"
                                                    value={rowsPerPage}
                                                    onChange={(e) => {
                                                        setRowsPerPage(Number(e.target.value));
                                                        setCurrentPage(1);
                                                    }}
                                                >
                                                    <option value={5}>5</option>
                                                    <option value={10}>10</option>
                                                    <option value={15}>15</option>
                                                </select>

                                                <span>entries</span>

                                            </div>

                                            <div className="small text-muted">
                                                Showing {startEntry} to {endEntry} of {totalRecords} entries
                                            </div>

                                            <Pagination
                                                currentPage={currentPage}
                                                totalPages={totalPages}
                                                maxPagesToShow={rowsPerPage}
                                                onPageChange={(page) => setCurrentPage(page)}
                                            />
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>

                    {isDrawerOpen && (
                        <AddRoles
                            mode="add"
                            roleList={[]} // pass roles from API or state
                            onClose={handleCloseDrawer}
                            onSave={handleSave}
                        />

                    )}
                </div>

            }
        </div>

    );
};

export default RolesAndPermissions;  
